import { FormControl, Stack, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { Formik, Form as FormikForm } from "formik";
import { LogIn } from "lucide-react";
import { useHistory } from "react-router-dom";
import * as yup from "yup";

import { axiosInstance } from "api/request";
import { postLogin } from "api/user";
import { LoginPayloadType } from "api/user/types";
import FormikTextField from "components/forms/FormikTextField";
import UltimateButton from "components/UltimateButton";

const LoginForm = () => {
  const history = useHistory();
  const initialValues = {
    email: "",
    password: "",
    ...(process.env.NODE_ENV === "development" && {
      email: "kitanovicandrej213@gmail.com",
      password: "123456",
    }),
  };

  const schema = yup.object({
    email: yup.string().email("Wrong email format").required(),
    password: yup.string().required(),
  });

  const { mutateAsync: login, status } = useMutation(
    async (values: LoginPayloadType) => {
      const { data: loginData } = await postLogin(values);

      localStorage.setItem("JWToken", loginData?.token);
      axiosInstance.defaults.headers.common["Authorization"] =
        `Bearer ${loginData?.token}`;
    },
  );

  const handleSubmit = async (values: LoginPayloadType) => {
    await login(values, {
      onSuccess: () => history.push("/credit-evaluations"),
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              Email *
            </Typography>
            <FormikTextField name="email" placeholder="you@company.com" />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              Password *
            </Typography>
            <FormikTextField
              name="password"
              type="password"
              placeholder="Enter your password"
            />
          </FormControl>

          <UltimateButton
            type="submit"
            text="Sign In"
            loading={status === "loading"}
            Icon={
              LogIn as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            sx={{ mt: 1, py: 1 }}
          />
        </Stack>
      </FormikForm>
    </Formik>
  );
};

export default LoginForm;
